import { useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { buildWhatsAppUrl } from "@/lib/leadSource";

function getWhatsAppMessage(pathname: string) {
  if (pathname.startsWith("/catalogo")) {
    return "Olá! Estou navegando pelo catálogo e gostaria de um orçamento personalizado.";
  }
  if (pathname.startsWith("/crie-sua-marca")) {
    return "Olá! Quero personalizar produtos com a marca da minha óptica. Podem me enviar um orçamento?";
  }
  if (pathname.startsWith("/produto")) {
    return "Olá! Vi este produto no site do Atacado Óptico e quero saber condições de atacado e disponibilidade.";
  }
  if (pathname.startsWith("/lentes")) {
    return "Olá! Tenho interesse em lentes oftálmicas no atacado. Podem me enviar o catálogo e preços?";
  }
  if (pathname.startsWith("/carrinho")) {
    return "Olá! Montei um orçamento no site e gostaria de confirmar disponibilidade antes de enviar.";
  }
  return "Olá! Vim pelo site do Atacado Óptico e gostaria de saber mais sobre os produtos e condições de atacado.";
}

function getTooltipText(pathname: string) {
  if (pathname.startsWith("/produto")) return "Dúvidas sobre este produto?";
  if (pathname.startsWith("/carrinho")) return "Precisa de ajuda com seu orçamento?";
  if (pathname.startsWith("/crie-sua-marca")) return "Quer criar sua marca própria?";
  if (pathname.startsWith("/catalogo")) return "Quer um orçamento personalizado?";
  return "Precisa de ajuda? Fale conosco!";
}

export function WhatsAppFloat() {
  const { pathname } = useLocation();
  const [showTooltip, setShowTooltip] = useState(false);
  const message = getWhatsAppMessage(pathname);

  useEffect(() => {
    const timer = setTimeout(() => setShowTooltip(true), 4000);
    const hideTimer = setTimeout(() => setShowTooltip(false), 9000);
    return () => { clearTimeout(timer); clearTimeout(hideTimer); };
  }, [pathname]);

  return (
    <div className="fixed bottom-6 right-6 z-50 flex items-center gap-2">
      {showTooltip && (
        <div
          className="bg-white text-gray-800 text-sm px-3 py-2 rounded-lg shadow-lg animate-fade-in max-w-52 cursor-pointer border border-green-100"
          onClick={() => setShowTooltip(false)}
        >
          <p className="font-semibold text-green-700 text-xs mb-0.5">Atendimento via WhatsApp</p>
          {getTooltipText(pathname)}
        </div>
      )}
      <a
        href={buildWhatsAppUrl(message)}
        target="_blank"
        rel="noopener noreferrer"
        className="flex h-14 w-14 items-center justify-center rounded-full shadow-lg transition-transform hover:scale-110 sm:h-16 sm:w-16"
        style={{ backgroundColor: "#25D366" }}
        aria-label="Abrir WhatsApp para atendimento"
      >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        className="h-7 w-7 fill-white sm:h-8 sm:w-8"
      >
        <path d="M16.004 0h-.008C7.174 0 0 7.176 0 16c0 3.5 1.132 6.742 3.052 9.376L1.056 31.2l6.064-1.952A15.9 15.9 0 0 0 16.004 32C24.826 32 32 24.822 32 16S24.826 0 16.004 0zm9.31 22.608c-.39 1.098-1.932 2.01-3.15 2.276-.834.178-1.924.32-5.594-1.202-4.694-1.946-7.71-6.716-7.944-7.026-.226-.31-1.846-2.462-1.846-4.694 0-2.232 1.168-3.33 1.584-3.784.39-.424.912-.6 1.2-.6.152 0 .286.008.408.014.416.018.624.042.898.694.342.814 1.176 2.874 1.278 3.082.104.21.202.478.076.768-.118.296-.22.478-.432.738-.21.258-.44.458-.652.74-.19.244-.406.506-.172.922.234.414 1.04 1.716 2.234 2.782 1.536 1.372 2.83 1.798 3.23 1.998.4.2.634.168.868-.1.242-.276 1.034-1.2 1.31-1.614.274-.414.548-.346.922-.208.378.138 2.392 1.13 2.802 1.336.41.208.682.31.782.478.098.168.098.978-.292 2.078z" />
      </svg>
      <span className="absolute -top-1 -right-1 flex h-4 w-4">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-green-400 opacity-75" />
        <span className="relative inline-flex h-4 w-4 rounded-full bg-green-500" />
      </span>
    </a>
    </div>
  );
}
